import { StyleSheet as PDFStyleSheet } from '@react-pdf/renderer'

const styles = PDFStyleSheet.create({
  mainDiv: {
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center'
  },
  qrImage: {
    width: '70%'
  }
})
export default styles
